/**
 * User notes and admin notes.
 */

export function useTaskNotes(localSprint, setLocalSprint, recordAction) {
  /**
   * User-visible notes (`task.notes`): historical mission body for user-level API access.
   */
  const handleNotesChange = (taskId, notes) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldNotes = task?.notes || '';

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t => 
          t.id === taskId ? { ...t, notes, updatedAt: new Date().toISOString() } : t
        ),
      };
    });

    if (recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_NOTES',
        description: `${taskName}: User notes changed`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, notes: oldNotes } : t),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t => t.id === taskId ? { ...t, notes } : t),
            };
          });
        },
      });
    }
  };

  /** Admin-only rich text (`task.internalNotes`). Omitted from user-level API responses. */
  const handleInternalNotesChange = (taskId, internalNotes) => {
    const task = localSprint?.tasks?.find(t => t.id === taskId);
    const oldInternal = task?.internalNotes || '';

    setLocalSprint(prev => {
      if (!prev) return prev;
      const tasks = prev.tasks || [];
      return {
        ...prev,
        tasks: tasks.map(t =>
          t.id === taskId ? { ...t, internalNotes, updatedAt: new Date().toISOString() } : t
        ),
      };
    });

    if (recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_INTERNAL_NOTES',
        description: `${taskName}: Admin notes changed`,
        undo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t =>
                t.id === taskId ? { ...t, internalNotes: oldInternal } : t
              ),
            };
          });
        },
        redo: () => {
          setLocalSprint(prev => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map(t =>
                t.id === taskId ? { ...t, internalNotes } : t
              ),
            };
          });
        },
      });
    }
  };

  return {
    handleNotesChange,
    handleInternalNotesChange,
  };
}
